import { render, staticRenderFns } from "./NewSubscriptionModal.vue?vue&type=template&id=020807e0"
import script from "./NewSubscriptionModal.vue?vue&type=script&lang=js"
export * from "./NewSubscriptionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports